export function getFieldColors(state) {
    if (state === 'error') {
        return {
            border: 'var(--form-border-error, #dc2626)',
            ring: 'var(--form-ring-error, rgba(220,38,38,0.12))',
        };
    }
    if (state === 'success') {
        return {
            border: 'var(--form-border-success, #16a34a)',
            ring: 'var(--form-ring-success, rgba(22,163,74,0.12))',
        };
    }
    return {
        border: 'var(--form-border-focus, #2563eb)',
        ring: 'var(--form-ring-focus, rgba(37,99,235,0.12))',
    };
}
export function getFieldBaseStyle(state) {
    const isDisabled = state === 'disabled';
    const isReadonly = state === 'readonly';
    const bg = isDisabled
        ? 'var(--form-bg-disabled, rgba(11,18,32,0.06))'
        : isReadonly
            ? 'var(--form-bg-muted, rgba(11,18,32,0.04))'
            : 'var(--form-bg, #fff)';
    return {
        background: bg,
        color: 'var(--form-fg, #0b1220)',
        borderColor: 'var(--form-border, rgba(11,18,32,0.22))',
    };
}
